import React from "react";
import AccordionItem from "../common/AccordionItem";
import { Card } from "luna-react/components/card";

export default () => {
  return (
    <Card className="cookie_policy__wrapper">
      <div className="section_header center-text">
        <h1 className="section_title">Our Cookie Policy</h1>
        <span className="section_subtext">&nbsp;</span>
      </div>
      {policyContents.map(({ title, content }, index) => (
        <AccordionItem key={index} title={title}>
          {content}
        </AccordionItem>
      ))}
    </Card>
  );
};

export const policyContents = [
  {
    title: "What are Cookies?",
    content: (
      <p>
        We use the term Cookie to describe cookies and similar technologies such
        as tags and pixels. Cookies are small data files that websites place on
        your computer, laptop or mobile device.
      </p>
    ),
  },
  {
    title: "What do we use cookies and similar technologies for?",
    content: (
      <div>
        <ul>
          <li>
            To improve the performance of our websites by understanding which
            parts work well, and which don't.{" "}
          </li>
          <li>
            To enable us to collect information about how you and other people
            use our websites.
          </li>
          <li>
            To improve your experience on our websites, for example we use
            Cookies to remember the products you've put in your basket and to
            personalise your experience; and
          </li>
          <li>
            To deliver relevant online advertising to you both on our websites
            and elsewhere. This is sometimes done by combining data that we
            already have about you with the data collected through Cookies.
            These Cookies are placed by us and selected third parties and enable
            adverts to be presented to you on our and third party websites.
          </li>
          <li>
            To measure how effective our online advertising and marketing
            communications are.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "What is Digital Advertising?",
    content: (
      <p>
        When we say Digital Advertising we are referring to the adverts that you
        are shown while you are browsing our websites and other sites on the
        internet. They are set by us or by carefully selected third parties.
      </p>
    ),
  },
  {
    title: "What types of Cookies do we use?",
    content: (
      <div>
        <p>We use the following Cookies:</p>
        <ul>
          <li>
            <strong>Strictly Necessary Cookies.</strong> These are Cookies that
            are required for the operation of our website. They are necessary
            for the safety, security and integrity of the site. For example they
            help support the structure of the pages that are displayed to you,
            help to improve navigation and allow you to return to pages you have
            previously visited. This type of Cookie only lasts for the duration
            of the time you are visiting the website. When you leave the website
            they are deleted automatically.
          </li>
          <li>
            <strong>Performance and analytical Cookies.</strong> They allow us
            to recognise and count the number of visitors and to see how
            visitors move around our website when they are using it. This helps
            us to improve the way our website works, for example, by ensuring
            that users are finding what they are looking for easily. The data is
            aggregated and anonymised, which means we cannot identify you as an
            individual.{" "}
          </li>
          <li>
            <strong>Functionality Cookies.</strong> These are used to recognise
            you when you return to our website. This enables us to personalise
            our content for you, greet you by name and remember your preferences
            (for example, your choice of language or region). These Cookies will
            remain on your device until you choose to clear it. If you choose to
            do this, you will need to enter your details each time you visit the
            site.{" "}
          </li>
          <li>
            <strong>Digital Advertising Cookies.</strong> These Cookies will
            collect information about your browsing habits and allow us to show
            you adverts while you are browsing our site and other sites on the
            internet. We use these Cookies and personal data, including
            transaction data, to help give you the best experience on our site
            and to allow us and third parties to customise and measure the
            effectiveness of the marketing content you see across websites, apps
            and elsewhere, including social media. This may involve some limited
            sharing of personal data with third parties.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title:
      "How to decline Cookies and say no to your personal data being used for Digital Advertising",
    content: (
      <div>
        <p>
          You can decline Cookies and stop your data being used for Digital
          Advertising by saying 'No' when presented with the banner at the start
          of your journey. And you can manage your preferences at any time by
          selecting Manage Cookies or Cookie Preferences on our websites.{" "}
        </p>
      </div>
    ),
  },
  {
    title: "Contact us",
    content: (
      <div>
        <p>
          If you have a question about this policy please contact us by one of
          the following means:
        </p>
        <div>
          <div>
            By email:{" "}
            <a href="mailto:privacy@sainsburys.co.uk">
              privacy@sainsburys.co.uk
            </a>
          </div>
          <div>
            By post: Data Protection Officer at Privacy Team, Sainsbury's
            Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL
          </div>
          <p>
            You also have the right to lodge a complaint with the UK regulator,
            the Information Commissioner. Go to ico.org.uk/concerns to find out
            more.
          </p>
        </div>
      </div>
    ),
  },
  {
    title: "Policy change",
    content: (
      <div>
        <p>
          This cookie policy was most recently updated in January 2025. If we
          make changes to it, then we will take appropriate steps to bring those
          changes to your attention.
        </p>
      </div>
    ),
  },
];



// WEBPACK FOOTER //
// ./src/components/pages/CookiePolicy.js